module.exports = __webpack_public_path__ + "img/shuizhi.ba4e71c5.png";